import React from 'react';
import Logo from "../assets/logoSin.png";
import { Link } from 'react-scroll';

const Header = () => {
  return (
      <header className='py-8'>
          <div className='container mx-auto'>
              <div className="flex justify-between items-center">

                <a href="https://freelance.habr.com/freelancers/SinCode">
                  <img src={Logo} alt="#" className='ml:w-[150px] ml:h-[40px] mo:w-[200px] mo:h-[65px] object-contain'/>
                </a>
                <Link to='contact' activeClass='active' smooth={true} spy={true} className='flex justify-center items-center btn btn-sm cursor-pointer mi:text-[0.65rem] mo:h-[45px] mo:px-[1.5rem] ml:px-[0.8rem] ml:h-[35px] ml:text-[0.55rem] mo:text-[0.875rem]'>Work with me</Link>
              </div>
          </div>
      </header>
  )
};

export default Header;
